





























































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useQuery, useResult } from '@vue/apollo-composable';

import useHighChartMap from '@/useHighChartMap';

import getDeliveryCostPerPackage from '@/gql/report/analytic/getDeliveryCostPerPackage.gql';

import Heatmap from '@/components/Map/Heatmap.vue';

const NOW = new Date();

const ExpenseByTransferItem = defineComponent({
  components: {
    Heatmap,
  },
  setup() {
    const { getProperty } = useHighChartMap();
    const toDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toCurrency = (string: string) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    const getYear = (date: string) => useFormat.date(date).dayjs.get('year');
    const backwardTenYear = Array.from({ length: 10 }, (x, i) => new Date().getFullYear() + 543 - i);
    const filter = reactive({
      range: {
        from: useFormat.date(NOW).computerShortDate(),
        to: useFormat.date(NOW).computerShortDate(),
      },
    });
    const computedFilter = computed(() => {
      if (filter.range.from === filter.range.to) return {};
      return {
        range: {
          from: useFormat.date(filter.range.from).computerShortDate(),
          to: useFormat.date(filter.range.to).computerShortDate(),
        },
      };
    });
    const donutType = [
      { display: 'By Top Hub/Branch (%T)', name: 'topHub' },
      { display: 'By Top Area (%T)', name: 'topArea' },
      { display: 'By Top Province (%T)', name: 'topProvince' },
      { display: 'By Bottom Hub/Branch (%T)', name: 'bottomHub' },
      { display: 'By Bottom Area (%T)', name: 'bottomArea' },
      { display: 'By Bottom Province (%T)', name: 'bottomProvince' },
    ];

    const { result: getDeliveryCostPerPackageResult } = useQuery(getDeliveryCostPerPackage, () => ({
      timeframe: computedFilter.value.range,
    }));
    const packagePrice = useResult(getDeliveryCostPerPackageResult, [], (data) => data.deliveryCostPerPackagePrice);
    const topHubs = useResult(getDeliveryCostPerPackageResult, [], (data) => data.topHubs);
    const bottomHubs = useResult(getDeliveryCostPerPackageResult, [], (data) => data.bottomHubs);
    const topAreas = useResult(getDeliveryCostPerPackageResult, [], (data) => data.topAreas);
    const bottomAreas = useResult(getDeliveryCostPerPackageResult, [], (data) => data.bottomAreas);
    const topProvinces = useResult(getDeliveryCostPerPackageResult, [], (data) => data.topProvinces);
    const bottomProvinces = useResult(getDeliveryCostPerPackageResult, [], (data) => data.bottomProvinces);
    const provinces = useResult(getDeliveryCostPerPackageResult, [], (data) => data.provinces);

    const thMonthsMini = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];
    const selectedYear = ref(new Date().getFullYear() + 543);
    const computedSeriesData = computed(() => packagePrice.value.map((val: any) => ({
      x: thMonthsMini[val.month - 1],
      y: toCurrency(val.ratio),
    })));

    const areaCharts = computed(() => ({
      options: {
        dataLabels: { enabled: false },
        yaxis: {
          opposite: false,
          labels: {
            formatter: (val: any) => toCurrency(val),
          },
        },
      },
      series: [
        {
          name: 'ต้นทุนค่าบริการขนส่ง (บาท)',
          data: computedSeriesData.value,
        },
      ],
    }));

    const colorIndex = ref(0);
    const COLORS = ['pink', 'green', 'blue', 'yellow', 'red', 'gray', 'orange', 'teal', 'indigo', 'purple'];
    function getColor() {
      if (colorIndex.value === 9) colorIndex.value = 0;
      else colorIndex.value += 1;
      return COLORS[colorIndex.value];
    }

    const donutChart = computed(() => {
      let topHub: any = [];
      if (topHubs.value.length === 0) topHub = [];
      else {
        topHub = topHubs.value.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.ratio,
          color: getColor(),
        }));
      }

      let topArea: any = [];
      if (topAreas.value.length === 0) topHub = [];
      else {
        topArea = topAreas.value.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.ratio,
          color: getColor(),
        }));
      }

      let topProvince: any = [];
      if (topProvinces.value.length === 0) topHub = [];
      else {
        topProvince = topProvinces.value.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.ratio,
          color: getColor(),
        }));
      }

      let bottomHub: any = [];
      if (topHubs.value.length === 0) topHub = [];
      else {
        bottomHub = bottomHubs.value.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.ratio,
          color: getColor(),
        }));
      }

      let bottomArea: any = [];
      if (bottomAreas.value.length === 0) topHub = [];
      else {
        bottomArea = bottomAreas.value.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.ratio,
          color: getColor(),
        }));
      }

      let bottomProvince: any = [];
      if (bottomProvinces.value.length === 0) topHub = [];
      else {
        bottomProvince = bottomProvinces.value.map((areaElm: any) => ({
          name: areaElm.name,
          data: areaElm.ratio,
          color: getColor(),
        }));
      }

      return {
        topHub,
        bottomHub,
        topArea,
        bottomArea,
        topProvince,
        bottomProvince,
      };
    });

    const computedData = computed(() => {
      const _value: any = {
        northern: [],
        northeastern: [],
        central: [],
        eastern: [],
        western: [],
        southern: [],
      };

      function pushToArray(_region: string, province: string | number, value: number | string) {
        if (_region === 'NORTHERN') _value.northern.push([`th-${province}`, value]);
        else if (_region === 'NORTHEASTERN') _value.northeastern.push([`th-${province}`, value]);
        else if (_region === 'CENTRAL') _value.central.push([`th-${province}`, value]);
        else if (_region === 'EASTERN') _value.eastern.push([`th-${province}`, value]);
        else if (_region === 'WESTERN') _value.western.push([`th-${province}`, value]);
        else if (_region === 'SOUTHERN') _value.southern.push([`th-${province}`, value]);
      }

      const hasValue: number[] = [];
      provinces.value.forEach((elm: any) => {
        hasValue.push(elm.name);
        const { shortForm, region } = getProperty(elm.name);
        pushToArray(region, shortForm, toCurrency(elm.ratio));
      });
      for (let i = 0; i < 78; i += 1) {
        if (hasValue.indexOf(i) === -1) {
          const { shortForm, region } = getProperty(i);
          pushToArray(region, shortForm, 0);
        }
      }
      return _value;
    });

    return {
      toCurrency,
      toDate,
      getYear,
      filter,

      donutType,
      areaCharts,
      donutChart,
      backwardTenYear,
      selectedYear,

      computedData,

      packagePrice,
    };
  },
});

export default ExpenseByTransferItem;
